// extracted by mini-css-extract-plugin
export default {"parent":"LRText_parent__NHLZC","right":"LRText_right__OQaAV"};